import { render, staticRenderFns } from "./RecommendedInternetOfferTile.vue?vue&type=template&id=ecbaa070&scoped=true&"
import script from "./RecommendedInternetOfferTile.vue?vue&type=script&lang=js&"
export * from "./RecommendedInternetOfferTile.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedInternetOfferTile.vue?vue&type=style&index=0&id=ecbaa070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbaa070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecbaa070')) {
      api.createRecord('ecbaa070', component.options)
    } else {
      api.reload('ecbaa070', component.options)
    }
    module.hot.accept("./RecommendedInternetOfferTile.vue?vue&type=template&id=ecbaa070&scoped=true&", function () {
      api.rerender('ecbaa070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/RecommendedInternetOfferTile.vue"
export default component.exports